import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_COMPLEMENTS_BY_PRODUCT_ID = '[COMPLEMENTS] GET COMLEMENTS BY PRODUCT ID'
export const SAVE_PRODUCT_COMPLEMENT = '[COMPLEMENTS] SAVE PRODUCT COMLEMENT'
export const UPDATE_PRODUCT_COMPLEMENT_QUANTITY = '[COMPLEMENTS] UPDATE PRODUCT COMLEMENT QUANTITY'
export const REMOVE_PRODUCT_COMPLEMENT = '[COMPLEMENTS] REMOVE PRODUCT COMLEMENT'

export function getComplementsByProductId(productId) {
  const request = api.get(`/product-complements/by-product-id/${productId}`)
  return (dispatch) => {
    dispatch({ type: GET_COMPLEMENTS_BY_PRODUCT_ID, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_COMPLEMENTS_BY_PRODUCT_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener los complementos del producto")
      console.log(GET_COMPLEMENTS_BY_PRODUCT_ID, error)
    }).finally(() => {
      dispatch({ type: GET_COMPLEMENTS_BY_PRODUCT_ID, payload: { loading: false } })
    })
  }
}

export function saveProductComplement(data) {
  const request = api.post(`/product-complements/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_PRODUCT_COMPLEMENT, payload: { saving: true } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_PRODUCT_COMPLEMENT, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo guardar el complemento")
      console.log(SAVE_PRODUCT_COMPLEMENT, error)
    }).finally(() => {
      dispatch({ type: SAVE_PRODUCT_COMPLEMENT, payload: { saving: false, saved: false } })
    })
  }
}

export function updateProductComplementQuantity(complementId, quantity) {
  const request = api.put(`/product-complements/update-quantity/${complementId}/${quantity}`)
  return (dispatch) => {
    dispatch({ type: UPDATE_PRODUCT_COMPLEMENT_QUANTITY, payload: { updating_id: complementId } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UPDATE_PRODUCT_COMPLEMENT_QUANTITY, payload: { updated_id: complementId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo actualizar la cantidad del complemento")
      console.log(UPDATE_PRODUCT_COMPLEMENT_QUANTITY, error)
    }).finally(() => {
      dispatch({ type: UPDATE_PRODUCT_COMPLEMENT_QUANTITY, payload: { updating_id: complementId } })
    })
  }
}

export function removeProductComplement(complementId) {
  const request = api.delete(`/product-complements/remove/${complementId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_PRODUCT_COMPLEMENT, payload: { removing_id: complementId } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_PRODUCT_COMPLEMENT, payload: { removed_id: complementId } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo remover el complemento")
      console.log(REMOVE_PRODUCT_COMPLEMENT, error)
    }).finally(() => {
      dispatch({ type: REMOVE_PRODUCT_COMPLEMENT, payload: { removing_id: complementId } })
    })
  }
}
